export default __webpack_public_path__ + "static/media/Oral Presentation Room 2.0b8aaa70.JPG";